var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 d-flex flex-column",attrs:{"id":"app"}},[_c('chat'),_c('div',{staticClass:"height"},[_c('Header'),(_vm.timerBarVisible)?_c('LineTimer'):_vm._e(),_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }